import { getRefundAdminGuidance } from "../../../../../data/flight/order/getRefundAdminGuidance";

function PricingSectionPending({ data }) {
  const { statusLabel, description } = getRefundAdminGuidance(data);

  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">Refund</h2>
      </div>

      <div className="bg-primary1/5 p-4 text-sm text-gray-700 gap-2 flex flex-col">
        <div className="bg-[#FE9F29]/10 w-full rounded-md min-h-9 px-3 flex items-center justify-center text-[#FE9F29] font-semibold text-sm text-center">
          {statusLabel}
        </div>
        <span className="text-xs text-gray-600 text-center">{description}</span>
      </div>
    </div>
  );
}

export default PricingSectionPending;
